import { render, staticRenderFns } from "./SellingPointSection.vue?vue&type=template&id=4420a1cc&scoped=true"
import script from "./SellingPointSection.vue?vue&type=script&lang=js"
export * from "./SellingPointSection.vue?vue&type=script&lang=js"
import style0 from "./SellingPointSection.vue?vue&type=style&index=0&id=4420a1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4420a1cc",
  null
  
)

export default component.exports